<template>
  <div class="fusionGateway">
    <div class="the-banner"></div>
    <div class="bgbox-gray">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="module1-conts">
          <div class="img-box">
            <img :src="require('@/assets/images/fusionGateway-module1-1.png')" />
          </div>
          <div class="infos-box">
            <div class="item">
              <p>有效降低酒店设备购置成本</p>
            </div>
            <div class="item">
              <p>实现酒店的精细化运营管理</p>
            </div>
            <div class="item">
              <p>节省运维人员人工维护成本</p>
            </div>
            <div class="item">
              <p>企业发展提供产品技术支撑</p>
            </div>
          </div>
        </div>
      </el-col>
    </div>
    <div class="bgbox-white">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="module2-conts">
          <div class="view1">
            <p><span class="title">神行者融合网关</span>是同迅科技针对酒店定制的一款全新产品。以优化上网体验、定制专属电视系统、提供网络安全保障为前提，融合了<span>「路由流控」「智能桌面」「日志审计」</span>三大系统。实现其网络管理需要的所有功能。有效降低酒店设备购置成本，节省运维人员人工维护成本，实现精细化运营管理，为酒店未来发展提供产品、技术支撑。</p>
            <img :src="require('@/assets/images/fusionGateway-module2-1.png')" />
          </div>
          <div class="view2">
            <div class="module-title">
              酒店新旧网络方案对比
            </div>
            <div class="conts">
              <div class="view-tab"> 
                <div class="btn-box">
                  <button :class="[this.tabVal?'active':'']" @click="module2Tab(1)">传统方案</button>
                  <button :class="[this.tabVal?'':'active']" @click="module2Tab(2)">神行者方案</button>
                </div>
              </div>
              <div class="view-tabconts">
                <div class="tabconts" :class="[this.tabVal?'':'dnone']">
                  <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                    <div class="img-box">
                      <img :src="require('@/assets/images/fusionGateway-module2-2.png')" />
                    </div>
                  </el-col>
                  <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                    <div class="infos-box">
                      <p class="line1">传统酒店接入方案由于技术受限或者其他原因，主要存在以下问题：</p>
                      <p class="line2">铜线线缆多，成本高，故障排查困难，单次定位30分钟以上</p>
                      <p class="line2">单点故障影响大，维修成本高</p>
                      <p class="line2">缺少统一管理平台，人工定位费时费力</p>
                      <p class="line2">其他问题，不一而足</p>
                    </div>
                  </el-col>
                </div>
                <div class="tabconts" :class="[this.tabVal?'dnone':'']">
                  <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                    <div class="img-box">
                      <img :src="require('@/assets/images/fusionGateway-module2-3.png')" />
                    </div>
                  </el-col>
                  <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:12}">
                    <div class="infos-box">
                      <p class="line1">神行者【光路解决方案】采用最新的研发技术让原本的n根线才能解决的问题用一根线就能搞定，优势：</p>
                      <p class="line2">每个房间仅需一条线，急速定位问题区域，及时修复！</p>
                      <p class="line2">单点故障影响小，最大化降低维修成本！</p>
                      <p class="line2">三合一融合网关，统一管理，提高运维效率！</p>
                    </div>
                  </el-col>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </div>
    <div class="bgbox-gray">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="module3-conts">
          <div class="view">
            <div class="conts">
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:10}">
                <div class="img-box">
                  <img :src="require('@/assets/images/fusionGateway-module3-1.jpg')" />
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:14}">
                <div class="infos-box">
                  <h3>融合网关 — 1.路由流控</h3>
                  <p>神行者路由，是一款基于SDN构架而实现的流量控制管理系统。系统架构主要由应用特征库、应用识别系统、应用管理系统、应用路由四大部分组成，并通过系统管理、网络管理、策略管理、监控统计、面板管理五大人机互动管理功能对流经的所有应用数据进行实时监控与管理。</p>
                  <p>神行者路由具备专业的协议特征库，并有先进的更新维护机制，同级硬件的整体性能高，处于国内领先水平。</p>
                  <p>X86硬件架构和PCI Express总线技术发展，提供了高性能、通用的硬件平台；Xspeeder在此平台上带来了更强的核心竞争力。</p>
                  <div class="btn-box">
                    <router-link to="/main/routeDev"><el-button size="small" type="primary" plain>查看详情</el-button></router-link>
                  </div>
                </div>
              </el-col>
            </div>
          </div>
          <div class="view">
            <div class="conts">
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:14}">
                <div class="infos-box">
                  <h3>融合网关 — 2.智能桌面系统</h3>
                  <p>神行者智能桌面，基于HLS技术开发网络直播一体化解决方案。系统采用标准流媒体输出，部署简单，任何网络架构都可轻松接入。</p>
                  <p>带机量大，支持wifi传输，全中文自动安装，后台界面简洁明了，简单好用易操作。</p>
                  <p>服务器采集视频数据，通过资源口实时缓冲一定时间内数据，可添加硬盘保存数据。服务器可自定义界面，控制apk信息展示。</p>
                  <p>APK基于安卓系统开发，兼容大部分智能电视，机顶盒，接入网络简单，自动跟服务器通信。</p>
                  <div class="btn-box">
                    <router-link to="/main/smartTV"><el-button size="small" type="primary" plain>查看详情</el-button></router-link>
                  </div>
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:10}">
                <div class="img-box">
                  <img :src="require('@/assets/images/fusionGateway-module3-2.jpg')" />
                </div>
              </el-col>
            </div>
          </div>
          <div class="view">
            <div class="conts">
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:10}">
                <div class="img-box">
                  <img :src="require('@/assets/images/fusionGateway-module3-3.jpg')" />
                </div>
              </el-col>
              <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:12}" :lg="{span:14}">
                <div class="infos-box">
                  <h3>融合网关 — 3.日志审计</h3>
                  <p>神行者日志（XspeederLog）是基于公司多年经验推出的基于大数据架构的新一代日志审计系统。</p>
                  <p>针对客户部署的神行者路由流控设备实现日志数据的高效采集、统一管理、集中存储、统计分析。如针对排名、分布、趋势和相似性分析，提供IP 轨迹、TOP域名、应用流量流向图、URL 地图、TOP 用户、连接可视化分析和DNS 可视化分析等为代表的分析工具，并可协助运营商高效统一管理网络日志并为安全事件的事后取证提供依据。</p>
                  <p>系统基于SOA架构设计，采用B/S 管理模式。</p>
                  <p>系统由日志采集、日志处理、日志管理、事件监测、日志存储、统计分析、告警响应以及系统管理八个子系统构成。各子系统相互耦合、协作，保证整个系统稳定、高效。</p>
                  <div class="btn-box">
                    <router-link to="/main/logAudit"><el-button size="small" type="primary" plain>查看详情</el-button></router-link>
                  </div>
                </div>
              </el-col>
            </div>
          </div>
        </div>
      </el-col>
    </div>
    <div class="bgbox-white">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="module4-conts">
          <div class="module-title">
            <span class="title-cn">合作酒店品牌</span>
            <span class="title-en">COOPERATIVE HOTEL BRAND</span>
          </div>
          <div class="view">
            <el-col :xs="{span:8}" :sm="{span:6}" :md="{span:4}" :lg="{span:4}">
              <div class="img-box">
                <img :src="require('@/assets/images/fusionGateway-module4-1.jpg')" />
              </div>
            </el-col>
            <el-col :xs="{span:8}" :sm="{span:6}" :md="{span:4}" :lg="{span:4}">
              <div class="img-box">
                <img :src="require('@/assets/images/fusionGateway-module4-2.jpg')" />
              </div>
            </el-col>
            <el-col :xs="{span:8}" :sm="{span:6}" :md="{span:4}" :lg="{span:4}">
              <div class="img-box">
                <img :src="require('@/assets/images/fusionGateway-module4-3.jpg')" />
              </div>
            </el-col>
            <el-col :xs="{span:8}" :sm="{span:6}" :md="{span:4}" :lg="{span:4}">
              <div class="img-box">
                <img :src="require('@/assets/images/fusionGateway-module4-4.jpg')" />
              </div>
            </el-col>
            <el-col :xs="{span:8}" :sm="{span:6}" :md="{span:4}" :lg="{span:4}">
              <div class="img-box">
                <img :src="require('@/assets/images/fusionGateway-module4-5.jpg')" />
              </div>
            </el-col>
            <el-col :xs="{span:8}" :sm="{span:6}" :md="{span:4}" :lg="{span:4}">
              <div class="img-box">
                <img :src="require('@/assets/images/fusionGateway-module4-6.jpg')" />
              </div>
            </el-col>
            <el-col :xs="{span:8}" :sm="{span:6}" :md="{span:4}" :lg="{span:4}">
              <div class="img-box">
                <img :src="require('@/assets/images/fusionGateway-module4-7.jpg')" />
              </div>
            </el-col>
            <el-col :xs="{span:8}" :sm="{span:6}" :md="{span:4}" :lg="{span:4}">
              <div class="img-box">
                <img :src="require('@/assets/images/fusionGateway-module4-8.jpg')" />
              </div>
            </el-col>
            <el-col :xs="{span:8}" :sm="{span:6}" :md="{span:4}" :lg="{span:4}">
              <div class="img-box">
                <img :src="require('@/assets/images/fusionGateway-module4-9.jpg')" />
              </div>
            </el-col>
            <el-col :xs="{span:8}" :sm="{span:6}" :md="{span:4}" :lg="{span:4}">
              <div class="img-box">
                <img :src="require('@/assets/images/fusionGateway-module4-10.jpg')" />
              </div>
            </el-col>
            <el-col :xs="{span:8}" :sm="{span:6}" :md="{span:4}" :lg="{span:4}">
              <div class="img-box">
                <img :src="require('@/assets/images/fusionGateway-module4-11.jpg')" />
              </div>
            </el-col>
            <el-col :xs="{span:8}" :sm="{span:6}" :md="{span:4}" :lg="{span:4}">
              <div class="img-box">
                <img :src="require('@/assets/images/fusionGateway-module4-12.jpg')" />
              </div>
            </el-col>
          </div>
        </div>
      </el-col>
    </div>
    <div class="bgbox-gray">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="module4-conts">
          <div class="module-title">
            <span class="title-cn">融合网关产品配置清单</span>
            <span class="title-en">PRODUCT CONFIGURATION</span>
          </div>
          <div class="module5">
            <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:12}">
              <div class="module5-img">
                <img class="img5-1" :src="require('@/assets/images/fusionGateway-module5-1.jpg')" />
              </div>
            </el-col>
            <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:12}">
              <div class="module5-img">
                <img class="img5-2" :src="require('@/assets/images/fusionGateway-module5-2.jpg')" />
              </div>
            </el-col>
          </div>
        </div>
      </el-col>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabVal: true
    };
  },
  methods:{
    module2Tab(val){
      if(val == 1){
        this.tabVal = true;
      }else{
        this.tabVal = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.bgbox-white {
  padding: 50px 10px;
  overflow: hidden;
  background: #fff;
  box-sizing: border-box;
}
.bgbox-gray {
  padding: 50px 10px;
  overflow: hidden;
  background: #f7f7f7;
  box-sizing: border-box;
}
.the-banner {
  height: 400px;
  background-image: url("../../../assets/images/fusionGateway-banner1.jpg");
  background-repeat: no-repeat;
  background-position: center;
}

.module1-conts{
  .img-box{
    margin-bottom: 40px;
    img{
      display: block;
      width: 100%;
      max-width: 550px;
      margin: 0 auto;
    }
  }
  .infos-box{
    width: 100%;
    max-width: 720px;
    margin: 0 auto;
    overflow: hidden;
    .item{
      width: 300px;
      height: 56px;
      background: #3067ba;
      padding: 15px 0 0 28px;
      box-sizing: border-box;
      float: left;
      margin: 0 30px 20px 30px;
      p{
        height: 26px;
        line-height: 26px;
        font-size: 16px;
        color: #fff;
        padding-left: 40px;
        box-sizing: border-box;
        background: url('../../../assets/images/fusionGateway-module1-icon.png') no-repeat;
        background-position: left center;
      }
    }
  }
}

.module2-conts{
  .view1{
    margin-bottom: 50px;
    p{
      font-size: 16px;
      color: #1f1f1f;
      margin-bottom: 40px;
      span{
        color: #3067ba;
        &.title{
          font-size: 20px;
        }
      }
    }
    img{
      display: block;
      width: 100%;
      max-width: 765px;
      margin: 0 auto;
    }
  }
  .view2{
    background: #f5f5f5;
    padding: 50px 0;
    .module-title{
      text-align: center;
      font-size: 24px;
      color: #212121;
      line-height: 1;
      padding-bottom: 20px;
      position: relative;
      &::after{
        content: "";
        position: absolute;
        width: 70px;
        height: 2px;
        background: #1f1f1f;
        bottom: 0;
        left: 50%;
        margin-left: -35px;
      }
    }
    .conts{
      padding-top: 40px;
      .view-tab{
        margin-bottom: 40px;
        .btn-box{
          overflow: hidden;
          width: 240px;
          margin: 0 auto;
          text-align: center;
          button{
            padding: 6px 12px;
            color: #409eff;
            background: #ecf5ff;
            border-color: #b3d8ff;
            border: 1px solid;
            cursor: pointer;
            outline: none;
            &:first-child{
              margin-right: 10px;
            }
            &:hover{
              background: #409eff;
              border-color: #409eff;
              color: #fff;
            }
            &.active{
              background: #409eff;
              border-color: #409eff;
              color: #fff;
            }
          }
        }
      }
      .view-tabconts{
        .tabconts{
          overflow: hidden;
          &.dnone{
            display: none;
          }
          .img-box{
            padding: 0 20px;
            box-sizing: border-box;
            img{
              width: 100%;
              max-width: 678px;
              display: block;
              margin: 0 auto;
            }
          }
          .infos-box{
            padding: 40px 20px 0 20px;
            box-sizing: border-box;
            .line1{
              font-size: 16px;
              color: #3067ba;
              margin-bottom: 30px;
            }
            .line2{
              font-size: 16px;
              color: #1f1f1f;
              margin-bottom: 10px;
              padding-left: 20px;
              position: relative;
              &::after{
                content: "";
                width: 8px;
                height: 8px;
                position: absolute;
                background: #3067ba;
                border-radius: 50%;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
              }
            }
          }
        }
      }
    }
  }
}

.module3-conts{
  .view{
    width: 100%;
    box-sizing: border-box;
    margin-bottom: 10px;
    .conts{
      width: 100%;
      padding: 20px;
      box-sizing: border-box;
      background: #fff;
      overflow: hidden;
      .img-box{
        img{
          display: block;
          width: 100%;
          max-width: 330px;
          margin: 0 auto;
        }
      }
      .infos-box{
        padding: 10px 0;
        box-sizing: border-box;
        h3{
          font-size: 20px;
          color: #3067ba;
          margin-bottom: 30px;
        }
        p{
          font-size: 14px;
          line-height: 20px;
          color: #1f1f1f;
          padding-left: 20px;
          position: relative;
          margin-bottom: 20px;
          &::after{
            content: "";
            width: 8px;
            height: 8px;
            position: absolute;
            background: #3067ba;
            border-radius: 50%;
            left: 0;
            top: 6px;
          }
        }
      }
    }
  }
}

.module4-conts{
  .module-title{
    text-align: center;
    padding-bottom: 40px;
    .title-cn{
      display: block;
      font-size: 24px;
      color: #212121;
    }
    .title-en{
      display: block;
      font-size: 12px;
      font-weight: 400;
      color: #757575;
      line-height: 20px;
    }
  }
  .view{
    overflow: hidden;
    .img-box{
      padding: 5px;
      box-sizing: border-box;
      img{
        width: 100%;
        border: 1px solid #eee;
        box-sizing: border-box;
        transition: all 0.3s ease;
        &:hover{
          transform: translate3d(0, -2px, 0);
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        }
      }
    }
  }
}

.module5{
  overflow: hidden;
  .module5-img{
    img{
      width: 100%;
      display: block;
      margin: 0 auto;
      &.img5-1{
        max-width: 438px;
      }
      &.img5-2{
        max-width: 512px;
      }
    }
  }
}

// 移动端css
@media screen and (max-width: 767px) {
  .the-banner{
    height: 260px;
    background-image: url("../../../assets/images/fusionGateway-banner2.jpg");
  }

  .module1-conts{
    .infos-box{
      .item{
        float: initial;
        margin:0 auto;
      }
    }
  }
  .module2-conts{
    .conts{
      .view-tabconts{
        .tabconts{
          .img-box{
            padding: 0 10px;
          }
          .infos-box{
            padding: 0 10px;
          }
        }
      }
    }
  }
  .module3-conts{
    .view{
      .conts{
        padding: 10px;
      }
    }
  }
}
</style>